import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { User } from 'anchor-shared/lib/model/entity/user';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { ActivatedRoute, Router } from '@angular/router';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-for-hire',
  templateUrl: './for-hire.component.html',
  styleUrls: ['./for-hire.component.scss'],
})
export class ForHireComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  waterBody: WaterBody;
  waterBodyId: number;
  @Input() limit: number = 100;
  @Input() showSearch: boolean = true;
  @Input() isSkippers: boolean = false;

  public captains: Captain[];
  public waterBodies: WaterBody[];
  public noCaptainsFound: boolean;

  constructor(
    private captainDAO: CaptainDAO,
    private waterBodyDAO: WaterBodyDAO,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    const dataSub = this.route.data.subscribe((data) => {
      this.waterBodyId = data.portal.waterBodyResolve.id;
      this.waterBody = data.portal.waterBodyResolve;
      this.noCaptainsFound = true;
      if (this.showSearch) {
        this.waterBodies = data.portal.WaterBodiesResolve;
        this.updateCaptains(data.portal.captainResolve, this.limit);
      } else {
        if (this.waterBody) {
          this.updateCaptains(data.portal.captainResolve, this.limit);
        }
      }
    });
    this.subs.push(dataSub);
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  getCaptainName(captain: Captain): string {
    const lastInitial = captain.user.lastName.charAt(0);
    if (captain.uscgLicensed) {
      return (
        'Capt. ' + captain.user.firstName + ' ' + lastInitial.toUpperCase()
      );
    } else {
      return captain.user.firstName + ' ' + lastInitial.toUpperCase();
    }
  }

  updateCaptains(captains: Captain[], limit: number) {
    this.captains = captains.filter((captain) => {
      if (this.isSkippers) {
        return !captain.uscgLicensed && captain.captainForHire;
      } else {
        return captain.uscgLicensed && captain.captainForHire;
      }
    });
    if (this.captains.length > limit) {
      this.captains = this.captains.slice(0, limit);
    }
    if (this.captains.length > 0) {
      this.noCaptainsFound = false;
    } else {
      this.noCaptainsFound = true;
    }
  }

  goToProfile(captainId: number) {
    this.router.navigate(['captain-info', captainId]);
  }
}
